import { render, staticRenderFns } from "./LateIrrigations.vue?vue&type=template&id=2b167944"
import script from "./LateIrrigations.vue?vue&type=script&lang=js"
export * from "./LateIrrigations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports